<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/github-md-documents-prefetch.html" name="c-github-md-documents-prefetch">
<link rel="ractive" href="../components/markdown.html" name="c-markdown">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-github-md-documents-prefetch></c-github-md-documents-prefetch>
	<c-notification></c-notification>
	<c-header></c-header>

	<div class="p-privacy-policy">
		<div class="please-wait-sign {{#if @shared.tuText && @shared.ppText && @shared.spText}} not-displayed{{/if}}">
			Please wait while the document loads.
		</div>

		<div class="dropdown {{#unless @shared.tuText && @shared.ppText && @shared.spText}} not-displayed{{/unless}}">
			<div class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<span>Navigation</span>
				<div class="toggle-icon">
					<div class="toggle-bar"></div>
					<div class="toggle-bar"></div>
				</div>
			</div>
			<ul class="dropdown-menu">
				<li>
					<div class="dropdown-subtitle">Documents:</div>
				</li>
				<li>
					<a href="/terms/terms-of-use"
						class="dropdown-item {{#if currentPolicy === 'terms-of-use'}}active{{/if}}">
						Terms of Use
					</a>
				</li>
				<li>
					<a href="/terms/privacy-policy"
						class="dropdown-item {{#if currentPolicy === 'privacy-policy'}}active{{/if}}">
						Privacy Policy
					</a>
				</li>
<!--				<li>-->
<!--					<div class="dropdown-subtitle">Website - jsdelivr.com</div>-->
<!--				</li>-->
<!--				<li>-->
<!--					<a href="/terms/privacy-policy-jsdelivr-com"-->
<!--						class="dropdown-item {{#if currentPolicy === 'privacy-policy-jsdelivr-com'}}active{{/if}}">-->
<!--						Privacy Policy-->
<!--					</a>-->
<!--				</li>-->
			</ul>
		</div>

		<div class="page-content {{#unless @shared.tuText && @shared.ppText && @shared.spText}} not-displayed{{/unless}}">
			<div class="page-content_side-menu">
				<div class="menu-section">
					<strong class="section-title">Documents:</strong>

					<div class="section-list">
						<div>
							<a href="/terms/terms-of-use"
								class="{{#if currentPolicy === 'terms-of-use'}}active{{/if}}">
									Terms of Use
							</a>
						</div>

						<div>
							<a href="/terms/privacy-policy"
								class="{{#if currentPolicy === 'privacy-policy'}}active{{/if}}">
									Privacy Policy
							</a>
						</div>
					</div>
				</div>

<!--				<div class="horizontal-divider"></div>-->

<!--				<div class="menu-section">-->
<!--					<strong class="section-title">Website - jsdelivr.com</strong>-->

<!--					<div class="section-list">-->
<!--						<a href="/terms/privacy-policy-jsdelivr-com"-->
<!--							class="{{#if currentPolicy === 'privacy-policy-jsdelivr-com'}}active{{/if}}">-->
<!--								Privacy Policy-->
<!--						</a>-->
<!--					</div>-->
<!--				</div>-->
			</div>

			<div class="page-content_main">
				<h1 class="page-content_main_title">Terms &amp; Policies</h1>

				{{#if currentPolicy === 'privacy-policy'}}
					<c-markdown markdown="{{@shared.ppText}}"></c-markdown>
				{{elseif currentPolicy === 'sub-processors'}}
					<c-markdown markdown="{{@shared.spText}}"></c-markdown>
				{{else}}
					<c-markdown markdown="{{@shared.tuText}}"></c-markdown>
				{{/if}}
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	const listeners = require('../../assets/js/utils/listeners');

	component.exports = {
		data () {
			return {
				title: 'Terms & Policies - jsDelivr',
				currentPolicy: 'terms-of-use',
			};
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.stickySidebarScrollListener(this);
			}
		},
	};
</script>
